import { useMemo } from 'react';
import { spaces } from '../assets/styles/themes/tokens';
import useScreenSize from '../utils/useScreenSize';

interface ResponsivePaddingConfig {
  xs?: string;
  lg?: string;
  md?: string;
}

const useResponsivePadding = (config?: ResponsivePaddingConfig): string => {
  const { isXsScreen, isLgScreen } = useScreenSize();

  return useMemo(() => {
    const {
      xs = spaces.md,
      lg = spaces.xl,
      md = spaces.lg,
    } = config || {};

    if (isLgScreen) return lg;
    if (isXsScreen) return xs;
    return md;
  }, [config, isLgScreen, isXsScreen]);
};

export default useResponsivePadding;
